import { shouldShowGoalCompletionBanner } from '@griply/utils';
import Typography from '@mui/material/Typography';
import { useGoals, useUpdateGoal } from 'features/goals';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LifeAreaRocket } from 'shared/assets/icons';
import { Alert, Colors as AlertColors } from 'shared/components/ui/alert';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { PageSectionBase } from 'shared/components/ui/page-section-base';
import { useCompleteGoal } from 'shared/contexts/complete-goal';
import { useTaskCounts } from 'shared/contexts/task-counts/use-task-counts';
import { Goal } from 'shared/types/goal';

import * as Styled from './completion-banner.style';

export type CompletionBannerProps = {
  goal: Goal;
};

export const CompletionBanner: React.FC<CompletionBannerProps> = ({ goal }) => {
  const { t } = useTranslation();
  const goals = useGoals();
  const completeGoal = useCompleteGoal();
  const { submit } = useUpdateGoal();

  const taskCounts = useTaskCounts();

  const onComplete = () => !!goal && completeGoal(goal);

  const onCloseAlert = () => {
    if (!goal) {
      return;
    }

    submit({
      id: goal.id,
      metadata: { ...(goal.metadata ?? {}), hideCompletionBanner: true },
    });
  };

  if (
    !shouldShowGoalCompletionBanner(goal, goals, taskCounts?.byGoalProgress)
  ) {
    return null;
  }

  return (
    <PageSectionBase noPadding>
      <Styled.CompletionBanner>
        <Alert
          startIcon={LifeAreaRocket}
          color={AlertColors.Success}
          onClose={onCloseAlert}
          action={
            <Button
              variant={Variants.Contained}
              color={Colors.Success}
              size={Sizes.Small}
              onClick={onComplete}
            >
              {t('pages.goal-detail.progress.complete-goal.button')}
            </Button>
          }
        >
          <Typography variant="caption" component="span">
            {t('pages.goal-detail.progress.complete-goal.description')}
          </Typography>
        </Alert>
      </Styled.CompletionBanner>
    </PageSectionBase>
  );
};
